import PMBTotalFooter from 'components/PMBTotalFooter'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { URL_DETAIL_TRANSACTION } from 'utils/pathUrl'
import { createOrderStaff } from '../purchaseCommodityAction'
import { setOrderBuyer, toggleModal } from '../purchaseCommoditySlice'
import { useSnackbar } from 'notistack'

const TotalAmountInfo = ({ isLoading, isSuccess, data }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { profile } = useSelector((s) => s.dashboard)
  const { orders } = useSelector((s) => s.purchaseCommmodity)
  const { enqueueSnackbar } = useSnackbar()

  const total = orders.item
    ?.map((e) => (!e.totalPrice ? 0 : e.totalPrice))
    ?.reduce((sum, e) => sum + e, 0)

  let checkUnits = orders?.item?.map((i, idx) => {
    let arr = []
    Object.values(orders?.item[idx]).forEach((i) => {
      if (i === undefined || i === '') {
        arr.push(true)
      } else {
        arr.push(false)
      }
    })
    if (arr.includes(true)) {
      return true
    } else {
      return false
    }
  })

  const payloadOrderModified = (orders) => {
    const payload = {
      ...orders,
      item: orders?.item?.map((e) => {
        return {
          ...e,
          price: Number(
            e?.price
              ?.replace?.(/\./g, '')
              ?.replace?.(/\,/g, '.')
              ?.slice?.(0, 15),
          ),
          amount: Number(
            e?.amount
              ?.replace?.(/\./g, '')
              ?.replace?.(/\,/g, '.')
              ?.slice?.(0, 15),
          ),
        }
      }),
    }

    const picId =
      orders?.seller?.otherPicUserId ||
      orders?.buyer?.otherPicUserId ||
      orders?.seller?.otherPicUser?.userId ||
      orders?.buyer?.otherPicUser?.userId
    if (picId) {
      payload.otherPicUserId = picId
    }

    return payload
  }

  const handleSavedContacts = (e) => {
    const saved =
      JSON.parse(localStorage.getItem(`savedContacts-${profile?.userId}`)) ?? []
    let newListComodities = [...saved]

    const updatedOptions = newListComodities.filter(
      (item) => item.userId !== e.userId,
    )

    updatedOptions.unshift(e)

    if (updatedOptions.length > 5) {
      const removedItem = updatedOptions.pop()

      newListComodities = {
        removedItem,
      }
    }

    localStorage.setItem(
      `savedContacts-${profile?.userId}`,
      JSON.stringify(updatedOptions),
    )
  }

  useEffect(() => {
    if (isSuccess)
      dispatch(
        setOrderBuyer({
          fullName: data?.ownerData?.name,
          phoneNumber: data?.ownerData?.phoneNumber,
          userId: data?.ownerData?.userId,
          ...(data?.ownerData?.otherPicUser && {
            otherPicUserId: data?.ownerData?.otherPicUser?.userId,
          }),
        }),
      )
  }, [dispatch, data, isSuccess])

  return (
    <PMBTotalFooter
      total={total}
      testId="purchase-form"
      isLoading={orders.isLoading}
      isDisable={
        total === 0 ||
        isLoading ||
        orders.isLoading ||
        !orders.seller ||
        checkUnits.includes(true) ||
        total < 50000
      }
      onSubmit={() => {
        let payloadOrder = { ...orders }
        delete payloadOrder.step
        delete payloadOrder.isLoading

        return dispatch(createOrderStaff(payloadOrderModified(payloadOrder)))
          .unwrap()
          .then((response) => {
            const escrowpaymentId =
              response?.data?.escrowpaymentId || response?.escrowpaymentId
            localStorage.removeItem(`userDataBuy-${profile?.userId}`)
            handleSavedContacts(orders?.seller)
            if (escrowpaymentId) {
              navigate(`${URL_DETAIL_TRANSACTION}/${escrowpaymentId}?type=BUY`)
            } else {
              dispatch(toggleModal())
            }
          })
          .catch((err) => {
            enqueueSnackbar(`${err}`, {
              variant: 'error',
            })
          })
      }}
    />
  )
}

export default TotalAmountInfo
